var domain = window.location.host;

export default {
	post: "http://" + domain + "/rest",
	// api: 'http://cloud-api.shiwujia.cn'
	api: ''
};
